import { Button, Center, HStack, PinInput, PinInputField, Stack, Text } from "@chakra-ui/react"

interface PinVerificationStepProps {
    email: string
    pin: string
    setPin: (pin: string) => void
    onSubmit: () => void
    onBackToLogin: () => void
    isLoading: boolean
    buttonColor: string
    hasError?: boolean
    errorMessage?: string
}

const PinVerificationStep = ({ email, pin, setPin, onSubmit, onBackToLogin, isLoading, buttonColor, hasError, errorMessage }: PinVerificationStepProps) => {
    return (
        <>
            <Stack textAlign={'center'}>
                <Text fontSize='3xl' fontWeight={'300'}>Enter Verification Code</Text>
            </Stack>
            <Stack spacing={0} mt={2} mb={5} textAlign={'center'}>
                <Text fontSize='md' fontWeight={'200'}>Please enter the 6-digit code</Text>
                <Text fontSize='md' fontWeight={'200'}>sent to {email}</Text>
            </Stack>
            <Stack spacing={5}>
                <Center>
                    <Stack spacing={2} align='center'>
                        <HStack>
                            <PinInput 
                                value={pin} 
                                onChange={(value) => setPin(value)}
                                size='lg'
                                manageFocus={true}
                                otp
                                isInvalid={hasError}>
                                <PinInputField borderColor={hasError ? 'red.500' : undefined} />
                                <PinInputField borderColor={hasError ? 'red.500' : undefined} />
                                <PinInputField borderColor={hasError ? 'red.500' : undefined} />
                                <PinInputField borderColor={hasError ? 'red.500' : undefined} />
                                <PinInputField borderColor={hasError ? 'red.500' : undefined} />
                                <PinInputField borderColor={hasError ? 'red.500' : undefined} />
                            </PinInput>
                        </HStack>
                        {errorMessage && (
                            <Text color='red.500' fontSize='sm'>
                                {errorMessage}
                            </Text>
                        )}
                    </Stack>
                </Center>
                <Stack>
                    <Button
                        isLoading={isLoading}
                        loadingText={'Verifying'}
                        onClick={onSubmit}
                        bg={buttonColor}
                        color={'white'}
                        _hover={{
                            bg: 'blue.400',
                        }}
                        isDisabled={pin.length !== 6}>
                        Submit
                    </Button>
                    <Button
                        bg={'white'}
                        onClick={onBackToLogin}
                        color={'blue.400'}
                        _hover={{
                            bg: 'white',
                        }}>
                        Back to Login
                    </Button>
                </Stack>
            </Stack>
        </>
    )
}

export default PinVerificationStep
